import { useQuery } from '@tanstack/react-query';
import { Download } from 'lucide-react';
import { api } from '../api.js';
import { Card, Button, PageHeader, Spinner, Badge } from '../components/ui.jsx';

export default function AuditLogPage() {
  const { data, isLoading } = useQuery({ queryKey: ['audit-log'], queryFn: () => api.listAuditLog({ limit: 200 }) });

  return (
    <>
      <PageHeader title="Audit log" description="Every state-changing action is logged for security and compliance."
        action={<a href="/api/v1/audit-log/export" target="_blank" rel="noreferrer">
          <Button variant="secondary"><Download className="w-4 h-4 mr-1.5" />Export CSV</Button>
        </a>} />

      {isLoading ? <div className="min-h-[20vh] grid place-items-center"><Spinner className="w-8 h-8 text-primary-600" /></div> : (
        <Card padding={false}>
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-wider text-ink-500 border-b border-ink-200">
              <tr>
                <th className="text-left py-3 px-4">When</th>
                <th className="text-left py-3 px-4">Actor</th>
                <th className="text-left py-3 px-4">Action</th>
                <th className="text-left py-3 px-4">Resource</th>
              </tr>
            </thead>
            <tbody>
              {(data?.events || []).map(e => (
                <tr key={e.id} className="border-b border-ink-100 hover:bg-ink-50/40">
                  <td className="py-2 px-4 text-ink-500 text-xs whitespace-nowrap">{new Date(e.created_at).toLocaleString('en-AU')}</td>
                  <td className="py-2 px-4 text-ink-700 text-xs font-mono">{e.actor_user_id || 'system'}</td>
                  <td className="py-2 px-4"><Badge variant={badgeForAction(e.action)}>{e.action}</Badge></td>
                  <td className="py-2 px-4 text-ink-500 text-xs">{e.resource_type ? `${e.resource_type}: ${e.resource_id}` : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}

function badgeForAction(a) {
  if (a.startsWith('auth.login.failure') || a.startsWith('auth.lockout') || a.startsWith('billing.payment.failed')) return 'red';
  if (a.startsWith('auth.')) return 'blue';
  if (a.startsWith('user.')) return 'purple';
  if (a.startsWith('group.') || a.startsWith('role.') || a.startsWith('permission.')) return 'amber';
  if (a.startsWith('assessment.completed')) return 'green';
  return 'grey';
}
